module.exports = __webpack_public_path__ + "octopus.9edfb27b59f3259a3ec6501e41aa6748.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/users/octopus.svg
// module id = 111
// module chunks = 1